module.exports = __webpack_public_path__ + "static/media/dark.860bc040.svg";